import { Feature } from '@/types/global';
import { useGeneralPartnerStore } from './store';

export function isFeatureEnabledForGeneralPartner(feature: Feature): boolean {
  return useGeneralPartnerStore().generalPartner?.enabledFeatures.includes(feature) ?? false;
}
